import { labelsByRoomType } from 'src/consts';
import { RoomType } from 'src/types';

import { BookingObjectType } from './types';

export const labelsByBookingObjectType: Record<BookingObjectType, string> = {
  [BookingObjectType.Desk]: 'Рабочее место',
  [BookingObjectType.MeetingRoom]: labelsByRoomType[RoomType.Meeting],
  [BookingObjectType.FocusRoom]: labelsByRoomType[RoomType.Focus],
  [BookingObjectType.PhoneRoom]: labelsByRoomType[RoomType.Phone],
  [BookingObjectType.Parking]: 'Парковочное место',
};
